export const EMAIL_REDIRECT_DAY_MS = 24 * 60 * 60 * 1000;

export const EMAIL_WARNING_REDIRECT_KEY = 'lastEmailProblemRedirect';
export const EMAIL_DELETE_REDIRECT_KEY = 'lastEmailDeleteRedirect';
export const EMAIL_PROBLEM_REDIRECT_KEY = 'lastEmailWarningRedirect';

const isDayPassed = (lastRedirect: string | null, now: number): boolean =>
    !lastRedirect || now - Number(lastRedirect) > EMAIL_REDIRECT_DAY_MS;

export const shouldRedirectEmailWarning = (
    createdAt: string | undefined,
    emailConfirmed: boolean | undefined,
    lastRedirect: string | null,
    now: number,
): boolean => {
    if (!createdAt || emailConfirmed) return false;
    if (now - new Date(createdAt).getTime() <= EMAIL_REDIRECT_DAY_MS) return false;
    return isDayPassed(lastRedirect, now);
};

export const shouldRedirectEmailDelete = (
    deleteDeadline: string | null | undefined,
    lastRedirect: string | null,
    now: number,
): boolean => {
    if (!deleteDeadline) return false;
    return isDayPassed(lastRedirect, now);
};

export const shouldRedirectEmailProblem = (
    lastEmailError: string | null | undefined,
    lastRedirect: string | null,
    now: number,
): boolean => {
    if (lastEmailError === null) return false;
    return isDayPassed(lastRedirect, now);
};
